// extracted by css-extract-rspack-plugin
export default {"root":"eqP53w","label":"Vl4VGt","value":"fW4cL_"};